import React from 'react';
import 'twin.macro';
import { Title } from '../text';
import { PidgeonIcon, AlsDanIcon } from 'icons';

export const Error = ({ children, label, ...restProps }) => (
  <>
    <div tw='p-8 mb-8 rounded-lg border-b border-secondary w-full'>
      <div tw='flex gap-4 justify-center items-center h-[200px] mb-8 w-full'>
        <PidgeonIcon tw='w-60' />
        <AlsDanIcon />
      </div>
      <div tw='text-center'>
        {label && <Title tw='text-center w-full mb-4'>{label}</Title>}
        {children}
      </div>
    </div>
  </>
);
